import { render, staticRenderFns } from "./TeachingProfileComponent.vue?vue&type=template&id=612c159c&scoped=true"
import script from "./TeachingProfileComponent.vue?vue&type=script&lang=js"
export * from "./TeachingProfileComponent.vue?vue&type=script&lang=js"
import style0 from "./TeachingProfileComponent.vue?vue&type=style&index=0&id=612c159c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612c159c",
  null
  
)

export default component.exports